import script from "./SlotAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotAlert.vue?vue&type=script&setup=true&lang=js"

import "./SlotAlert.vue?vue&type=style&index=0&id=37f924a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f924a8"]])

export default __exports__